import src from "IMAGE";
export default { src, width: 670, height: 46, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAEBAQIODxAhGBMjOxwVH0AWFxk3FBUXMgwNDh4AAAABK7ACopLDFPEAAAAASUVORK5CYII="};
